import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { ComponentsModule } from '../../components/components.module';
import { HomeRoutes } from './home.route-module';
import { RouterModule } from '@angular/router';
import { CommonModule } from "@angular/common";

@NgModule({
    declarations:[
        HomeComponent
    ],
    imports:[
        ComponentsModule,
        RouterModule.forRoot(
            HomeRoutes
        ),
        CommonModule
    ],
    exports:[
        HomeComponent
    ]
})
export class HomeModule {}